import { Typography } from "@material-ui/core";
import AlternateCardSections from "components/generics/AlternateCardSections";
import { createUseStyles } from "react-jss";
import BlockBox from "components/generics/BlockBox";
import { PRIMARY_BACKGROUND } from "utils/data";


const useStyles = createUseStyles({
    container: {
        marginTop: "60px",
    },
    image: {},
    "@media screen and (max-width:760px)": {
        image: {
            "& img": {
                width: "150px!important",
                height: "auto",
            }
        }
    }
})

function CoachSpecialties({
    data,
}) {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <BlockBox
                backgroundColor={PRIMARY_BACKGROUND}
            >
                <Typography
                    variant="h2"
                    className="center mtb20"
                >
                    {data.title}
                </Typography>
                <div>
                    <AlternateCardSections
                        imageClassName={classes.image}
                        data={data.coach_specialties_list}
                        centerSMTitles={true}
                    />
                </div>
            </BlockBox>
        </div>
    )
}

export default CoachSpecialties;